<template>
  <div class="datamain">
    <Header />
    <div class="databox">
      <ManagementHeader />
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../Header.vue';
import ManagementHeader from './Header.vue';

export default {
  name: 'management',
  components: {
    Header,
    ManagementHeader,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less">
@font-face {
  font-family: 'title';
  src: url('../../assets/font/title.ttf');
}

.databox {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 160px);
  background: rgba(0, 11, 47, 0.5);
  box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
  border-radius: 0px 0px 0px 0px;
  padding: 10px;
  display: flex;

  .content {
    flex: 1;
    margin-left: 10px;
  }
}
</style>
